import {
    Injectable,
    ApplicationRef,
    ComponentRef,
    Type,
    createComponent,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ConfirmModalComponent } from '../modal/confirm-modal.component';
import { AlertModalComponent } from '../modal/alert-modal.component';

@Injectable({ providedIn: 'root' })
export class ModalService {
    constructor(private appRef: ApplicationRef) {}

    async open<T>(component: Type<T>, inputs?: Partial<T>): Promise<any> {
        const componentRef: ComponentRef<T> = createComponent(component, {
            environmentInjector: this.appRef.injector,
        });

        if (inputs) {
            Object.assign(componentRef.instance as object, inputs);
        }

        this.appRef.attachView(componentRef.hostView);
        const domElem = (componentRef.hostView as any)
            .rootNodes[0] as HTMLElement;
        document.body.appendChild(domElem);

        try {
            return await firstValueFrom(
                (componentRef.instance as any).getResult(),
                { defaultValue: null },
            );
        } finally {
            this.appRef.detachView(componentRef.hostView);
            componentRef.destroy();
        }
    }

    confirm(message: string): Promise<boolean> {
        return this.open(ConfirmModalComponent, { message });
    }

    alert(
        messageOrResponse: string | any,
        type: 'success' | 'error' | 'warning' | 'info' = 'success',
        errors?: any,
    ): Promise<void> {
        let message = 'Berhasil!';
        let errorData = errors;
        let alertType = type;

        if (
            typeof messageOrResponse === 'object' &&
            messageOrResponse !== null
        ) {
            if (messageOrResponse.message) {
                message = messageOrResponse.message;
            } else if (typeof messageOrResponse.error === 'string') {
                message = messageOrResponse.error;
            } else {
                message = 'Terjadi kesalahan';
            }

            if (messageOrResponse.errors) {
                errorData = messageOrResponse.errors;
            }

            if (messageOrResponse.success === false && type === 'success') {
                alertType = 'error';
            }
        } else if (typeof messageOrResponse === 'string') {
            message = messageOrResponse;
        }

        return this.open(AlertModalComponent, {
            message,
            type: alertType,
            errors: errorData,
        });
    }
}
